import { createSurveyStyles } from '@sm/webassets/SurveyTheme/context';

type styleNames = 'container';
type StyleProps = { isPremiumCustom: boolean };

const useStyles = createSurveyStyles<styleNames, StyleProps>(theme => {
  return {
    container: ({ isPremiumCustom }) => ({
      background: isPremiumCustom ? theme?.primaryBackgroundColor : 'initial',
    }),
  };
});

export default useStyles;
